module.exports = __webpack_public_path__ + "img/arrived.1f2da930.png";